import WpToastManager from 'Wpds/components/toast/WpToastManager';

import * as api from '../api/UpdateAis.api';

export const createUpdate = data => {
  return api
    .createUpdate(data)
    .then(response => {
      return response;
    })
    .catch(response => {
      WpToastManager.danger('An error occurred');
      return response;
    });
};

export const fetchJiraProjectEpics = () => {
  return api.fetchJiraProjectEpics().then(response => response);
};

export const fetchAsanaWorkspaceProjects = () => {
  return api.fetchAsanaWorkspaceProjects().then(response => response);
};
